import { render, staticRenderFns } from "./LockRequestDialog.vue?vue&type=template&id=cf32ebe2&"
import script from "./LockRequestDialog.vue?vue&type=script&lang=js&"
export * from "./LockRequestDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LockRequestDialog.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports